import React from 'react';

const currencySymbol: Record<string, string> = {
  USD: '$', EUR: '€', GBP: '£', JPY: '¥', CAD: 'C$', AUD: 'A$', CHF: 'Fr',
};

export const getCurrencySymbol = (currency: string): string => {
  return currencySymbol[currency] || currency;
};

export const priceWithSymbol = (amount: string | null, currency: string): React.ReactElement | null => {
  if (!amount) return null;
  const symbol = getCurrencySymbol(currency);
  return React.createElement('small', null, `${amount}${symbol}`);
};
